// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"__videoWrapper___19Meh","noVideo":"__noVideo___DgWDA","videoWidth":"__videoWidth___2oGjQ"};